export const getUser = () => {
    const user = localStorage.getItem("user");

    if (!user || user === "undefined") {
        return null;
    }
    return JSON.parse(user);
};
